import { render, staticRenderFns } from "./index.vue?vue&type=template&id=adbba0bc&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adbba0bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/3ztxUiUz/0/ifirst/dt-survey/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('adbba0bc')) {
      api.createRecord('adbba0bc', component.options)
    } else {
      api.reload('adbba0bc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=adbba0bc&scoped=true&", function () {
      api.rerender('adbba0bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DtTinymce/index.vue"
export default component.exports